var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ckeditor',_vm._g({attrs:{"config":_vm.editorConfig,"editor":_vm.editor,"value":_vm.value},on:{"input":_vm.onInput}},_vm.listeners)),_c('image-gallery-modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }